import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import { useParams } from 'react-router-dom';

export const useFullEmployeeFormUrlParams = (): {
  groupId: string;
  periodId: string;
  subscriberId?: string;
  activeTabId?: string;
} => {
  const { groupId, periodId } = useParams<{ groupId: string; periodId: string; subscriberId: string }>();
  const query = useQueryParams();

  const subscriberId = query.get('subscriberId') || undefined;
  const activeTabId = query.get('activeTabId') || undefined;

  if (!groupId || !periodId) {
    throw new Error(
      `useEnrollmentDomainParams was not able to find all required params in the url! Found: groupId: ${groupId}, periodId: ${periodId}`,
    );
  }

  return { groupId, periodId, subscriberId, activeTabId };
};
